import $ from 'jquery';
import Cookies from 'js-cookie';

export function getUserInfo(onSuccess, engine, qtEngine) {
  $.ajax({
    url: `/user_account/user_info?engine=${qtEngine || engine}`,
    method: 'GET',
    success: onSuccess
  });
}

export function getStatistics(onSuccess) {
  $.ajax({
    url: '/user_account/get_statistics',
    method: 'GET',
    success: response => onSuccess(response)
  });
}

export function getUserFullInfo(onSuccess) {
  $.ajax({
    url: '/user_account/user_full_info',
    method: 'GET',
    success: onSuccess
  });
}

export function getUsersList(onSuccess, onError) {
  $.ajax({
    url: '/billing/get_users/',
    method: 'GET',
    success: response => onSuccess(response),
    error: () => onError()
  });
}

export function getUsageInfo(params, onSuccess, onError) {
  $.ajax({
    url: `/billing/server_usage_info?${params}`,
    method: 'GET',
    success: response => onSuccess(response),
    error: () => onError()
  });
}

export function shareUsageInfo(params, onSuccess, onError) {
  $.ajax({
    url: `/billing/share_usage_info?${params}`,
    method: 'GET',
    success: response => onSuccess(response),
    error: () => onError()
  });
}

export function sendResetPasswordEmail(data, onSuccess, onError) {
  $.ajax({
    url: '/user_account/logout/',
    method: 'POST',
    headers: {
      'X-CSRFToken': Cookies.get('csrftoken')
    }
  });
  $.ajax({
    url: '/user_account/password/reset/',
    method: 'POST',
    data,
    headers: {
      'X-CSRFToken': Cookies.get('csrftoken')
    },
    success: response => onSuccess(response),
    error: xhr => onError(xhr)
  });
}

export function confirmResetPassword(data, onSuccess, onError) {
  $.ajax({
    url: '/user_account/password/reset/confirm/',
    method: 'POST',
    data,
    success: response => onSuccess(response),
    error: xhr => onError(xhr)
  });
}